// Єдині підказки податків для форм нарахувань (ЗП/компенсація/лікарняний/відпустка).
// Реальна ставка ЄСВ — з документа (8.41% інвалід / 22% звичайна). НЕ ділимо
// esv_amount/база: при ліміті 15×МЗП або зарахуванні авансу сума ЄСВ — донарахування,
// тож ділення дало б нелогічну «ставку».

const fmt = (v: number) =>
  v.toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function trimNum(v: string | number | undefined): string {
  if (v == null) return '';
  const n = Number(v);
  return Number.isInteger(n) ? String(n) : String(n).replace(/0+$/, '').replace(/\.$/, '');
}

/** Підказка ЄСВ за реальною ставкою документа (8.41 інвалід / 22 звичайна). */
export function esvTipDoc(esvAmount: string | number | undefined, esvRate: string | number): string {
  const rate = Number(esvRate);
  const isDisab = rate < 20;
  const rateTxt = isDisab
    ? `пільгова ${trimNum(esvRate)}% (працівник з інвалідністю)`
    : `${trimNum(esvRate)}%`;
  const amt = Number(esvAmount ?? 0);
  if (!amt) return `Єдиний соціальний внесок роботодавця — ставка ${rateTxt}.`;
  return `Єдиний соціальний внесок роботодавця ${fmt(amt)} — ставка ${rateTxt}.`;
}
